import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { SecuredHomeModule } from '../secured-home/secured-home.module';
import { FormsModule } from '@angular/forms';
import { ProfileModule } from '../profile/profile.module';
import { CrossSellingModule } from '../cross-selling/cross-selling.module';
import { ForbiddenModule } from '../forbidden/forbidden.module';
import { SecuredSkeletonComponent } from './components/secured-skeleton/secured-skeleton.component';
import { V2HeaderComponent } from './components/v2-header/v2-header.component';
import { CustomerTrainingComponent } from './components/customer-training/customer-training.component';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { MatCardModule } from '@angular/material/card';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { HelpCenterComponent } from './components/help-center/help-center.component';
import { ManagedServicesModule } from '../managed-services/managed-services.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatChipsModule } from '@angular/material/chips';
import { PendingApprovalModule } from '../pending-approval/pending-approval.module';
import { ShopRedirectComponent } from './components/shop-redirect/shop-redirect.component';
import { GlobalSearchComponent } from './components/global-search/global-search.component';
import { SearchResultsComponent } from './components/global-search/components/search-results/search-results.component';
import { SearchResultComponent } from './components/global-search/components/search-result/search-result.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SidenavCollapsedComponent } from './components/sidenav-collapsed/sidenav-collapsed.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { MarkdownModule, MARKED_OPTIONS } from 'ngx-markdown';
import { markedOptionsFactory } from './utils/markdown-provider';
import { HttpClient } from '@angular/common/http';
import { MatInputModule } from '@angular/material/input';
import { NotificationsComponent } from './components/notifications/notifications.component';

const materialModules = [
  MatSelectModule,
  MatIconModule,
  MatButtonModule,
  MatMenuModule,
  MatTabsModule,
  MatTableModule,
  MatProgressSpinnerModule,
  MatTooltipModule,
  MatExpansionModule,
  MatDialogModule,
  MatListModule,
  MatChipsModule,
  MatProgressBarModule,
  MatBadgeModule,
  MatCardModule,
  MatSlideToggleModule,
  MatInputModule,
];

@NgModule({
  declarations: [
    SecuredSkeletonComponent,
    V2HeaderComponent,
    CustomerTrainingComponent,
    HelpCenterComponent,
    ShopRedirectComponent,
    GlobalSearchComponent,
    SearchResultsComponent,
    SearchResultComponent,
    SidenavCollapsedComponent,
    SidenavComponent,
    NotificationsComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    // routing,
    RouterModule,
    SecuredHomeModule,
    FormsModule,
    ProfileModule,
    CrossSellingModule,
    ForbiddenModule,
    PendingApprovalModule,
    ManagedServicesModule,
    materialModules,
    MatFormFieldModule,
    ReactiveFormsModule,
    NgxSkeletonLoaderModule,
    MarkdownModule.forRoot(),
  ],
  providers: [
    {
      provide: MARKED_OPTIONS,
      useFactory: markedOptionsFactory,
      deps: [HttpClient],
    },
  ],
})
export class SecuredSkeletonModule {}
